"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAttachmentRateLimitPropertySchema = exports.isDocxColumnConfigs = exports.isDocxColumnConfig = exports.isDocxFileInsertionOutputs = exports.isAthenaConfigQueries = exports.isAthenaConfigQuery = exports.isAthenaConfigRecurringQueries = exports.isAthenaConfigRecurringQuery = exports.isDeliverableArtifactPropertyConfig = exports.isDeliverableArtifactProperty = exports.isDeliverableProperties = exports.isDeliverableProperty = exports.isReportingOutputsDocxConfig = exports.isReportingOutputsXlsxConfig = exports.isReportingOutputsXlsxDataSheetOutputs = exports.isReportingOutputsXlsxDataSheetOutput = exports.isReportingInputsIntermediateFields = exports.isReportingInputsIntermediateField = exports.isReportingInputsDataAccessors = exports.isReportingInputsDataAccessor = exports.isGlobalRecurringDateConfigs = exports.isGlobalRecurringDateConfig = exports.isReportingInputsConfig = exports.isReportingMechanics = exports.isReportingProperty = exports.isRecurringDateProperty = exports.isFinancialCovenantConfig = exports.isFinancialCovenantProperties = exports.isFinancialCovenantProperty = exports.isPortfolioCovenantProperties = exports.isPortfolioCovenantProperty = exports.isQueryVariables = exports.isQueryVariable = exports.isBaseFieldConfigArray = exports.isBaseFieldConfig = exports.isNumericType = exports.isCalcAgentMechanicsDomain = exports.typeguardErrorCreditAgreementFullArtifact = exports.isBackupServicingMechanics = exports.isCreditAgreementFullArtifact = exports.isCreditAgreementArtifact = exports.isCreditAgreementDocument = exports.isConcentrationLimitCalculationSourceConfig = void 0;
const zod_1 = require("zod");
const schema = __importStar(require("../schema"));
const Config_1 = require("../types/CreditAgreement/Config");
const DataTapeField_1 = require("../types/CreditAgreement/DataTapeField");
const DomainEntity_1 = require("../types/CreditAgreement/DomainEntity");
const Log_1 = require("../types/Log");
const typeguardUtils_1 = require("./typeguardUtils");
const { ColumnConfigSchema } = Config_1.Reporting.Outputs.Docx;
const { AccessorSchema } = Config_1.Reporting.Inputs.DataAccessor;
const { FileInsertionOutputSchema, ConfigSchema: DocxConfigSchema, } = Config_1.Reporting.Outputs.Docx;
const { DataSheetOutputSchema: XlsxDataSheetOutputSchema, ConfigSchema: XlsxConfigSchema, } = Config_1.Reporting.Outputs.Xlsx;
const { ConfigSchema: InputsConfigSchema } = Config_1.Reporting.Inputs;
const { ConfigSchema: DeliverableArtifactPropertyConfigSchema, } = Config_1.DeliverableArtifactProperty;
exports.isConcentrationLimitCalculationSourceConfig = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: Config_1.ConcentrationLimit.CalculationSourceConfigSchema,
    typeguardName: 'isConcentrationLimitCalculationSourceConfig',
});
// Use Wire schema for validation (with cast for CreditAgreementDocument type)
exports.isCreditAgreementDocument = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: schema.CreditAgreementDocumentSchema,
    typeguardName: 'isCreditAgreementDocument',
});
// Use Wire schema for validation (with cast for CreditAgreementArtifact type)
exports.isCreditAgreementArtifact = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: schema.CreditAgreementArtifactSchema,
    typeguardName: 'isCreditAgreementArtifact',
});
// Use Wire schema for validation (with cast for CreditAgreementFullArtifact type)
exports.isCreditAgreementFullArtifact = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: schema.CreditAgreementFullArtifactSchema,
    typeguardName: 'isCreditAgreementFullArtifact',
});
exports.isBackupServicingMechanics = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: DomainEntity_1.BackupServicingMechanicsSchema,
    typeguardName: 'isBackupServicingMechanics',
});
exports.typeguardErrorCreditAgreementFullArtifact = (0, typeguardUtils_1.zodTypeguardErrorWrapper)({ schema: schema.CreditAgreementFullArtifactSchema });
// Use Wire schema for validation (with cast for CalcAgentMechanics type)
exports.isCalcAgentMechanicsDomain = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: schema.CalcAgentMechanicsSchema,
    typeguardName: 'isCalcAgentMechanicsDomain',
});
const isNumericType = (obj, logOptions) => {
    let errorMessage = '';
    if (typeof obj !== 'string') {
        errorMessage = 'NumericType typeguard failed: input is not a string';
    }
    else if (!DataTapeField_1.DataTapeField.NumericTypes.some((type) => type === obj)) {
        errorMessage = `NumericType typeguard failed: ${obj} is not NumericType option`;
    }
    if (errorMessage && logOptions?.logger) {
        logOptions.logger({ message: errorMessage }, logOptions.logLevel || Log_1.LogLevel.Error);
    }
    return errorMessage.length === 0;
};
exports.isNumericType = isNumericType;
exports.isBaseFieldConfig = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: schema.DataTapeField.BaseConfigSchema,
    typeguardName: 'isBaseFieldConfig',
});
exports.isBaseFieldConfigArray = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: zod_1.z.array(schema.DataTapeField.BaseConfigSchema),
    typeguardName: 'isBaseFieldConfigArray',
});
exports.isQueryVariable = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: schema.QueryVariableSchema,
    typeguardName: 'isQueryVariable',
});
const isQueryVariables = (obj, logOptions) => {
    if (!Array.isArray(obj)) {
        return false;
    }
    for (const el of obj) {
        if (!(0, exports.isQueryVariable)(el, logOptions)) {
            return false;
        }
    }
    return true;
};
exports.isQueryVariables = isQueryVariables;
exports.isPortfolioCovenantProperty = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: DomainEntity_1.PortfolioCovenantPropertySchema,
    typeguardName: 'isPortfolioCovenantProperty',
});
exports.isPortfolioCovenantProperties = (0, typeguardUtils_1.zodTypeguardArrayFunctionLogWrapper)({
    schema: DomainEntity_1.PortfolioCovenantPropertySchema,
    typeguardName: 'isPortfolioCovenantProperties',
});
exports.isFinancialCovenantProperty = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: DomainEntity_1.FinancialCovenantPropertySchema,
    typeguardName: 'isFinancialCovenantProperty',
});
exports.isFinancialCovenantProperties = (0, typeguardUtils_1.zodTypeguardArrayFunctionLogWrapper)({
    schema: DomainEntity_1.FinancialCovenantPropertySchema,
    typeguardName: 'isFinancialCovenantProperties',
});
exports.isFinancialCovenantConfig = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: Config_1.FinancialCovenant.ConfigSchema,
    typeguardName: 'isFinancialCovenantConfig',
});
exports.isRecurringDateProperty = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: schema.RecurringDatePropertySchema,
    typeguardName: 'isRecurringDateProperty',
});
exports.isReportingProperty = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: DomainEntity_1.ReportingPropertySchema,
    typeguardName: 'isReportingProperty',
});
exports.isReportingMechanics = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: DomainEntity_1.ReportingMechanicsSchema,
    typeguardName: 'isReportingMechanics',
});
exports.isReportingInputsConfig = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: InputsConfigSchema,
    typeguardName: 'isReportingInputsConfig',
});
exports.isGlobalRecurringDateConfig = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: Config_1.GlobalRecurringDate.ConfigSchema,
    typeguardName: 'isGlobalRecurringDateConfig',
});
const isGlobalRecurringDateConfigs = (obj, logOptions) => {
    if (!Array.isArray(obj)) {
        return false;
    }
    for (const el of obj) {
        if (!(0, exports.isGlobalRecurringDateConfig)(el, logOptions)) {
            return false;
        }
    }
    return true;
};
exports.isGlobalRecurringDateConfigs = isGlobalRecurringDateConfigs;
exports.isReportingInputsDataAccessor = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: AccessorSchema,
    typeguardName: 'isReportingInputsDataAccessor',
});
exports.isReportingInputsDataAccessors = (0, typeguardUtils_1.zodTypeguardArrayFunctionLogWrapper)({
    schema: AccessorSchema,
    typeguardName: 'isReportingInputsDataAccessors',
});
exports.isReportingInputsIntermediateField = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: Config_1.ReportingInputsIntermediateFieldSchema,
    typeguardName: 'isReportingInputsIntermediateField',
});
const isReportingInputsIntermediateFields = (obj, logOptions) => {
    if (!Array.isArray(obj)) {
        return false;
    }
    for (const el of obj) {
        if (!(0, exports.isReportingInputsIntermediateField)(el, logOptions)) {
            return false;
        }
    }
    return true;
};
exports.isReportingInputsIntermediateFields = isReportingInputsIntermediateFields;
exports.isReportingOutputsXlsxDataSheetOutput = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: XlsxDataSheetOutputSchema,
    typeguardName: 'isReportingOutputsXlsxDataSheetOutput',
});
exports.isReportingOutputsXlsxDataSheetOutputs = (0, typeguardUtils_1.zodTypeguardArrayFunctionLogWrapper)({
    schema: XlsxDataSheetOutputSchema,
    typeguardName: 'isReportingOutputsXlsxDataSheetOutputs',
});
exports.isReportingOutputsXlsxConfig = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: XlsxConfigSchema,
    typeguardName: 'isReportingOutputsXlsxConfig',
});
exports.isReportingOutputsDocxConfig = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: DocxConfigSchema,
    typeguardName: 'isReportingOutputsDocxConfig',
});
exports.isDeliverableProperty = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: DomainEntity_1.DeliverablePropertySchema,
    typeguardName: 'isDeliverableProperty',
});
exports.isDeliverableProperties = (0, typeguardUtils_1.zodTypeguardArrayFunctionLogWrapper)({
    schema: DomainEntity_1.DeliverablePropertySchema,
    typeguardName: 'isDeliverableProperties',
});
exports.isDeliverableArtifactProperty = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: DomainEntity_1.DeliverableArtifactPropertySchema,
    typeguardName: 'isDeliverableArtifactProperty',
});
exports.isDeliverableArtifactPropertyConfig = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: DeliverableArtifactPropertyConfigSchema,
    typeguardName: 'isDeliverableArtifactPropertyConfig',
});
exports.isAthenaConfigRecurringQuery = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: Config_1.AthenaConfigRecurringQuerySchema,
    typeguardName: 'isAthenaConfigRecurringQuery',
});
const isAthenaConfigRecurringQueries = (obj, logOptions) => {
    if (!Array.isArray(obj)) {
        return false;
    }
    for (const el of obj) {
        if (!(0, exports.isAthenaConfigRecurringQuery)(el, logOptions)) {
            return false;
        }
    }
    return true;
};
exports.isAthenaConfigRecurringQueries = isAthenaConfigRecurringQueries;
exports.isAthenaConfigQuery = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: Config_1.AthenaConfigQuerySchema,
    typeguardName: 'isAthenaConfigQuery',
});
const isAthenaConfigQueries = (obj, logOptions) => {
    if (!Array.isArray(obj)) {
        return false;
    }
    for (const el of obj) {
        if (!(0, exports.isAthenaConfigQuery)(el, logOptions)) {
            return false;
        }
    }
    return true;
};
exports.isAthenaConfigQueries = isAthenaConfigQueries;
exports.isDocxFileInsertionOutputs = (0, typeguardUtils_1.zodTypeguardArrayFunctionLogWrapper)({
    schema: FileInsertionOutputSchema,
    typeguardName: 'isDocxFileInsertionOutputs',
});
exports.isDocxColumnConfig = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: ColumnConfigSchema,
    typeguardName: 'isDocxColumnConfig',
});
exports.isDocxColumnConfigs = (0, typeguardUtils_1.zodTypeguardArrayFunctionLogWrapper)({
    schema: ColumnConfigSchema,
    typeguardName: 'isDocxColumnConfigs',
});
exports.isAttachmentRateLimitPropertySchema = (0, typeguardUtils_1.zodTypeguardFunctionLogWrapper)({
    schema: schema.AttachmentRateLimitPropertySchema,
    typeguardName: 'isAttachmentRateLimitPropertySchema',
});
//# sourceMappingURL=creditAgreement.js.map